import { connect } from 'react-redux'

const mapStateToApolloProps = ({ appSettings: { week, sessionType } }) => (
  { week, sessionType }
)

const withReduxForApollo = connect(mapStateToApolloProps)

export default withReduxForApollo
